var GALLERY_TYPE = 'wix-draft-plugin-gallery';
var getDefaultComponentData = function () { return ({
    items: [],
    styles: {
        galleryLayout: 2,
        gallerySizeType: 'px',
        gallerySizePx: 300,
        galleryMargin: 0,
        oneRow: false,
        cubeRatio: 1,
        galleryThumbnailsAlignment: 'bottom',
        isVertical: false,
        imageMargin: 20,
        thumbnailSpacings: 0,
        cubeType: 'fill',
        enableInfiniteScroll: true,
        titlePlacement: 'SHOW_ON_HOVER',
        allowHover: false,
        itemClick: 'link',
        fullscreen: false,
        showArrows: false,
        gridStyle: 1,
        loveButton: false,
        allowSocial: false,
        allowDownload: false,
        mobileSwipeAnimation: 'NO_EFFECT',
        thumbnailSize: 120,
        gotStyleParams: true,
        showVideoPlayButton: true,
        videoPlay: 'onClick',
    },
    config: {
        alignment: 'center',
        size: 'content',
        layout: 'small',
        spacing: 0,
    },
}); };
export { GALLERY_TYPE, getDefaultComponentData };
//# sourceMappingURL=types.js.map